import React from "react";
import styled from "styled-components";
import container from "container/BrokerDashboard/editAgentContainer";

const TableWrapper = styled.div`
  background: #fff;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: none !important;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 16px;
`;

const SectionTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 12px;
  border: none !important;

  th,
  td {
    text-align: left;
    padding: 12px;
    border: none;
  }

  th {
    font-weight: 600;
    color: #333;
    background: transparent;
  }

  /* Column width and alignment matching Associates section */
  th:first-child,
  td:first-child {
    width: 40%;
    text-align: left;
    padding-left: 16px;
  }

  th:nth-child(2),
  td:nth-child(2) {
    width: 37%;
    text-align: left;
  }

  th:last-child,
  td:last-child {
    width: 23%;
    text-align: center;
    padding-right: 32px;
  }
`;

const StyledCell = styled.td`
  color: #111827;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

const ReferralsSection = ({ getOnboardingReferralInfoResponse }) => {
  const { data } = getOnboardingReferralInfoResponse || {};

  return (
    <TableWrapper>
      <Header>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.75 9.75C6.75 9.33579 7.08579 9 7.5 9H16.5C16.9142 9 17.25 9.33579 17.25 9.75C17.25 10.1642 16.9142 10.5 16.5 10.5H7.5C7.08579 10.5 6.75 10.1642 6.75 9.75ZM7.5 13.5H16.5C16.9142 13.5 17.25 13.1642 17.25 12.75C17.25 12.3358 16.9142 12 16.5 12H7.5C7.08579 12 6.75 12.3358 6.75 12.75C6.75 13.1642 7.08579 13.5 7.5 13.5ZM21.75 5.25V19.5C21.7499 19.7599 21.6152 20.0012 21.394 20.1378C21.1729 20.2743 20.8968 20.2866 20.6644 20.1703L18 18.8381L15.3356 20.1703C15.1244 20.276 14.8756 20.276 14.6644 20.1703L12 18.8381L9.33562 20.1703C9.12436 20.276 8.87564 20.276 8.66438 20.1703L6 18.8381L3.33562 20.1703C3.1032 20.2866 2.82712 20.2743 2.60597 20.1378C2.38483 20.0012 2.25014 19.7599 2.25 19.5V5.25C2.25 4.42157 2.92157 3.75 3.75 3.75H20.25C21.0784 3.75 21.75 4.42157 21.75 5.25ZM20.25 5.25H3.75V18.2869L5.66437 17.3288C5.87564 17.223 6.12436 17.223 6.33563 17.3288L9 18.6619L11.6644 17.3288C11.8756 17.223 12.1244 17.223 12.3356 17.3288L15 18.6619L17.6644 17.3288C17.8756 17.223 18.1244 17.223 18.3356 17.3288L20.25 18.2869V5.25Z"
            fill="#111827"
          />
        </svg>
        <SectionTitle>Referrals</SectionTitle>
      </Header>

      {/* Add the check here after the heading */}
      {data?.length ? (
        <Table>
          <thead>
            <tr>
              <th>Full Name</th>
              <th>Phone</th>
              <th>Email address</th>
            </tr>
          </thead>
          <tbody>
            {data.map((referral, index) => (
              <tr key={index}>
                <StyledCell>
                  {referral.fullname ||
                    `${referral.firstname} ${referral.lastname}`}
                </StyledCell>
                <StyledCell>{referral.phone || "-"}</StyledCell>
                <StyledCell>{referral.email || "-"}</StyledCell>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <div style={{ textAlign: "center", padding: "40px", color: "#8c8c8c" }}>
          No referrals found.
        </div>
      )}
    </TableWrapper>
  );
};

export default container(ReferralsSection);
